import { Outlet } from '@tanstack/react-router';
import './styles/global.css';

export default function AppRoot() {
  return <Outlet />;
}
